import type {FC} from 'react'
import {useWindowSize} from 'react-use'
import {ButtonV2} from 'src/common/ButtonV2'
import {BREAKPOINTS} from 'src/common/constants'
// eslint-disable-next-line boundaries/dependencies -- grandfathered cross-slice import, predates the slice-boundaries rule
import {CustomSelect} from 'slices/IntegrationsContainer/CustomSelect'

type CategoryFilterProps = {
  categories: Array<{category_name: string; value: string}>
  activeIndex: number
  onCategoryChange: (index: number) => void
  onScroll: () => void
}

export const CategoryFilter: FC<CategoryFilterProps> = ({categories, activeIndex, onCategoryChange, onScroll}) => {
  const isMobile = useWindowSize().width < BREAKPOINTS.TABLET

  const handleClick = (index: number) => {
    onCategoryChange(index)
    onScroll()
  }

  if (isMobile) {
    return (
      <div className="z-10">
        <CustomSelect
          v2
          options={categories}
          activeIndex={activeIndex}
          setActiveIndex={handleClick}
          trackingData={{mktgId: 'blog-post-category-select', dataType: 'blog-post-category'}}
        />
      </div>
    )
  }

  return (
    <ul className="flex flex-wrap gap-2">
      {categories.map((category, index) => (
        <li className="cursor-pointer" key={category.category_name + index}>
          <ButtonV2
            variant={activeIndex === index ? 'primary' : 'secondary'}
            className="!h-[38px] !p-3"
            onClick={() => handleClick(index)}
            aria-pressed={activeIndex === index}
            trackingData={{
              mktgId: 'blog-post-category-button',
              dataType: 'blog-post-category',
              location: `category-${category.category_name}-${index}`,
            }}
          >
            {category.category_name}
          </ButtonV2>
        </li>
      ))}
    </ul>
  )
}
